<template>
<v-layout column fill-height justify-center align-center>
  <v-flex>
    <v-select :dark="$vuetify.theme.dark" :item-color="$vuetify.theme.dark?'grey darken-4':'white'" :solo="solo" flat v-model="selected" :items="languages" hide-details :dense="dense" @change="change" background-color="transparent">
      <template slot="item" slot-scope="{ item }" >
        <img :src="item.icon" class="pl-1 mr-4" height="25px" :alt="item.key"><span :class="`${ dense ? 'caption' : 'subheading' } ${$vuetify.theme.dark?'white--text':'grey--text text--darken-3'} `">{{ item.name }}</span>
      </template>
      <template slot="selection" slot-scope="{ item }" >
        <img :src="item.icon" class="pl-1 mr-4" height="25px" :alt="item.key" :style="solo ? 'margin-left: -12px !important' : ''"><span class="ml-3">{{ item.name }}</span>
      </template>
    </v-select>
  </v-flex>
</v-layout>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import variables from '@/custom/variables'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['dense', 'dark', 'solo'],
  data () {
    return {
      languages: variables.languages,
      selected: null
    }
  },
  computed: {
    ...mapState(['currentUser', 'userProfile', 'userJobs', 'categories', 'filteredCategories', 'status']),
    ...mapGetters(['getLanguage'])
  },
  methods: {
    async change (language) {
      var updates = {}
      updates[`/user/${this.currentUser.uid}/profile/language`] = language.key
      await fb.database.ref().update(updates)
    }
  },
  created: function () {
    this.selected = variables.languages.find(el => {
      return el.key === this.getLanguage
    })
  }
}
</script>
